import { useForm } from 'react-hook-form';
import { Dialog, IconButton, Stack, Typography, Button } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CloseIcon from '@mui/icons-material/Close';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Dayjs } from 'dayjs';

import { FormProvider, RHFDatePicker } from '@app/components';
import { Strings } from '@app/constants';

interface DateFilterDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  onDateChange: (value: [Dayjs | null, Dayjs | null]) => void;
}

const DateFilterDialog = ({ open, onClose, title, onDateChange }: DateFilterDialogProps) => {
  const methods = useForm({
    defaultValues: {
      startDate: null,
      endDate: null,
    },
  });

  const { watch } = methods;
  const startDate = watch('startDate');
  const endDate = watch('endDate');

  const handleApply = () => {
    if (startDate && endDate) {
      onDateChange?.([startDate, endDate]);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <FormProvider methods={methods}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" px={2} pt={2}>
            <Typography fontWeight="bold">{title}</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <Stack p={2} spacing={2}>
            <Stack direction="row" spacing={1}>
              <RHFDatePicker name="startDate" label="Start Date" />
              <RHFDatePicker name="endDate" label="End Date" />
            </Stack>
            <Button variant="contained" disabled={!startDate || !endDate} onClick={handleApply}>
              {Strings.button.apply}
            </Button>
          </Stack>
        </LocalizationProvider>
      </FormProvider>
    </Dialog>
  );
};

export { DateFilterDialog };
